import React from "react";
import CcFieldLayout, { resolveFieldMessage } from "./CcFieldLayout";
/**
 * Wraps CcTextField / CcSelect / custom inputs with a dedicated label, hint, and error.
 * Do not pass `label` to the child — only to CcFormField.
 */
const CcFormField = ({
  label,
  required = false,
  hint,
  error,
  helperText,
  children,
  className,
}) => {
  const { hasError, message } = resolveFieldMessage({
    error,
    helperText,
    hint,
  });

  return (
    <CcFieldLayout
      label={label}
      required={required}
      error={hasError ? message : undefined}
      hint={!hasError ? message : undefined}
      className={className}
    >
      {children}
    </CcFieldLayout>
  );
};

export default CcFormField;
